import React from 'react';
import InfoIcon from './InfoIcon';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

export const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <span className="logo-icon">⚡</span>
            <h1 className="logo-text">Energy Forecast</h1>
          </div>
          <div className="header-info">
            <span className="market-area">DE-LU</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <a 
            href="https://www.boersenmedien.de/impressum.html" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Impressum
          </a>
          <span className="footer-divider">|</span>
          <span className="footer-text">
            Datenquelle: EPEX SPOT
          </span>
        </div>
      </div>
    </footer>
  );
};

export const Container: React.FC<LayoutProps> = ({ children }) => {
  return <div className="container">{children}</div>;
};

export const TwoColumnGrid: React.FC<LayoutProps> = ({ children }) => {
  return <div className="two-column-grid">{children}</div>;
};

export const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">Lade Daten...</p>
    </div>
  );
};

export const ErrorMessage: React.FC<{ message: string }> = ({ message }) => {
  return (
    <div className="error-message">
      <span className="error-icon">⚠️</span>
      <p>{message}</p>
    </div>
  );
};

export const InfoCard: React.FC<{ 
  title: string; 
  value: string | number; 
  unit?: string; 
  highlight?: boolean;
  infoText?: string;
  infoTitle?: string;
}> = ({ 
  title, 
  value, 
  unit,
  highlight = false,
  infoText,
  infoTitle
}) => {
  return (
    <div className={`info-card ${highlight ? 'info-card-highlight' : ''}`}>
      <div className="info-card-header">
        <h3 className="info-card-title">{title}</h3>
        {infoText && (
          <InfoIcon 
            content={infoText} 
            title={infoTitle || `${title} erklären`}
          />
        )}
      </div>
      <div className="info-card-value">
        {value}
        {unit && <span className="info-card-unit">{unit}</span>}
      </div>
    </div>
  );
};